const checkSizeChartButton = () => {
  const sizeOptionTitle = document.querySelector(".tee-option--size");
  const popupLink = document.querySelector(".ks-chart-modal-button");

  if (sizeOptionTitle && popupLink) {
    const variantGroups = document.querySelector(".tee-variants");
    var existingClone = variantGroups.querySelector(".custom-trigger-button");
    if (!existingClone) {
      popupLink.style.display = "none";

      const button = document.createElement("div");
      button.className = "custom-trigger-button";

      button.innerHTML = popupLink.innerHTML;

      sizeOptionTitle.before(button);

      button.addEventListener("click", function () {
        popupLink.click();
      });
    }
  }
};

document.addEventListener("teeinblue-event-variant-changed", () => {
  const checkElementRendered = setInterval(() => {
    if (
      document.querySelector(".ks-chart-modal-button") &&
      document.querySelector(".tee-option--size")
    ) {
      checkSizeChartButton();
      clearInterval(checkElementRendered);
    }
  }, 200);
});

document.addEventListener("teeinblue-event-component-injected", () => {
  const checkElementRendered = setInterval(() => {
    if (
      document.querySelector(".ks-chart-modal-button") &&
      document.querySelector(".tee-option--size")
    ) {
      checkSizeChartButton();
      clearInterval(checkElementRendered);
    }
  }, 200);
});
setInterval(() => {
  const elements = document.querySelectorAll(".upcart-item-option");
  // console.log("elements", elements);
  elements.forEach((element) => {
    const content = element.textContent || element.innerText;
    if (content.includes("Available Product")) {
      element.remove();
    }
  });
}, 100);

const disableOpenCustomImageInNewTab = () => {
  setInterval(() => {
    var cartItems = document.querySelectorAll(".cart-item");
    cartItems.forEach((item) => {
      var productImage = item.querySelector(".tee-cart-thumbnail__link");
      if (productImage) {
        productImage.style.pointerEvents = "none";
        productImage.addEventListener("click", (e) => {
          e.preventDefault();
        });
      }
    });
  }, 300);
};

if (window.location.pathname === "/cart") {
  for (var count = 1; count <= 10; count++) {
    disableOpenCustomImageInNewTab();
  }
}

document.addEventListener("teeinblue-event-component-injected", function () {
  var deliveryInfo = document.querySelector(".arrivesby-dt");
  if (deliveryInfo) deliveryInfo.style.display = "none";
  var productPrice = document.querySelector(".tee-product-price");
  setTimeout(() => {
    if (deliveryInfo && productPrice) {
      deliveryInfo.style.marginTop = "-10px";
      deliveryInfo.style.display = "block";
      productPrice.insertAdjacentElement("afterend", deliveryInfo);
    }
  }, 1500);
});


window.onload = function () {
    function hideUploadStrong() {
        const strongProperties = document.querySelectorAll('.upcart-item-property strong');
        strongProperties.forEach(function (strongProperty) {
          if (strongProperty.textContent.trim().includes('Upload a photo') ||
              strongProperty.textContent.trim().includes('Upload your dog’s photo')) {
            strongProperty.parentElement.style.display = 'none';
          }
        });
    }

    hideUploadStrong();

    const targetNode = document.querySelector('#upCart');
    const config = { childList: true, subtree: true, characterData: true };

    const observer = new MutationObserver(function (mutationsList) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                hideUploadStrong();
            }
        }
    });

    observer.observe(targetNode, config);
};


